// components/Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Column */}
          <div>
            <h3 className="font-bold text-lg mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://modestoonice.com/about"
                  className="hover:text-gray-300"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="https://modestoonice.com/faq"
                  className="hover:text-gray-300"
                >
                  FAQ
                </a>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-gray-300">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media Column */}
          <div>
            <h3 className="font-bold text-lg mb-4">Social Media</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://www.facebook.com/modestoonice"
                  className="hover:text-gray-300"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/modestoonice/"
                  className="hover:text-gray-300"
                >
                  Instagram
                </a>
              </li>
            </ul>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-2">
              <li>
                <a href="tel:+12095051181" className="hover:text-gray-300">
                  (209) 505-1181
                </a>
              </li>
              <li>
                <a
                  href="mailto:modestoonice@gmail.com"
                  className="hover:text-gray-300"
                >
                  modestoonice@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* AppMockUp Column */}
          <div>
            <h3 className="font-bold text-lg mb-4">Modesto On Ice</h3>
            <p className="text-gray-300">
              Modesto On Ice presented by Modesto Subaru is an outdoor seasonal
              ice skating rink located in the heart of downtown Modesto.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
